import Voice from './src/main';

/* istanbul ignore next */
Voice.install = function(Vue) {
  Vue.component(Voice.name, Voice);
};

export default Voice;
